import { inputRMOValidation } from "./rmo/rmo-input-validations";
import { setDatePickers } from "./rmo/set-date-picker.js"
import { getFormattedDate, getFormattedDateYYYMMDD, getMoFormDataTransformed } from "./rmo/get-mo-data-transformed";
import { hideValidationMessage, showValidationMessage } from  "../form-validation-message.js";
import { changeFileInputListener } from "./rmo/change-file-listener";
import { changeMultipleAttributesOfInputs } from "./rmo/change-multiple-attributes";
import { fileSelectorFunctionality } from "./rmo/file-selector-functionality";
import { getDataFromUploadedFile } from "./rmo/get-base64-data-from-file";
import { addressAttachToLocationFields } from "./rmo/address-attach-rmo.js";
import { codeTransactionData } from './country-code-istransactional-v2.js';

const rmoHeader = document.getElementById('rmoHeader')
const landingScreen = document.getElementById('rmo-steps')
const moneyOrderStatusScreen = document.getElementById('rmo-verify-status')
const moDetailsScreen = document.getElementById('rmo-details')
const contactInfoScreen = document.getElementById('rmo-contact-info')
const reviewSubmitScreen = document.getElementById('rmo-review-submit-form')
const initialParamsRMO = new URLSearchParams(window.location.search);
const rmoStatusCheck = initialParamsRMO.get("rmoStatusCheck");

const formData = {}

if (landingScreen || moneyOrderStatusScreen || moDetailsScreen || contactInfoScreen || reviewSubmitScreen) {
    const contactInfoStateDropdownEl = contactInfoScreen.querySelector('#state-dropdown-ul');
    const contactInfoCountryDropdownEl = contactInfoScreen.querySelector('#country-dropdown-contact');
    const progressContact = document.querySelector('#progress-contact');
    const progressMo = document.querySelector('#progress-mo');
    const rmoDetailContinueBtn = moDetailsScreen.querySelector('#rmo-detail-continue-btn');
    const moInfoStateDropdownEl = moDetailsScreen.querySelector('#state-dropdown-ul');
    const moInfoCountryDropdownEl = moDetailsScreen.querySelector('#country-dropdown');
    const dopIconEl = moDetailsScreen.querySelector('#dop-icon-el');
    const moNumbers = ['']; // For duplicate check logic in validation util
    const reviewSubmitBtn = reviewSubmitScreen.querySelector('#review-submit-continue-button');
    const rmoConsent = reviewSubmitScreen.querySelector('#rmo-consent');
    const rmoSignature = reviewSubmitScreen.querySelector('#rmo-signature');
    const humanKeyEL = document.querySelector("#humanKeyReview");
    const rmoContactInfoContinueBtn = contactInfoScreen.querySelector("#rmoContactInfoContinueBtn");
    const contactInfoPhoneNumberEl = contactInfoScreen.querySelector('#contact-phone-number');
    const contactInfoFlagCode = contactInfoScreen.querySelector('.country-code-flag');
    const contactInfoCountryCodeUlDropDown = document.querySelector("#country-code-ul-dropdown");
    const contactInfoCountryCodeInputDiv = document.querySelector("#country-code-input-div");
    const inputCountryCode = document.querySelector("#country-dd");
    const parent = document.querySelector('.wu-container-progressbar');
    const bars = parent.querySelectorAll('.wu-progress-bar-gamma');
    const moNumberInput = moneyOrderStatusScreen.querySelector('#wu-input-mo-number');
    const amountInput = moneyOrderStatusScreen.querySelector('#wu-input-mo-amount');
    const rmoStateKey = { ...USAStates, ...CanadaStates };
    const rmoStepsBtn = moneyOrderStatusScreen.querySelector('#rmoStepsContinueBtn');

    const moStatusEventId = rmoStepsBtn.getAttribute('amplitude-page-id');
    const moOrderDetailsEventId = rmoDetailContinueBtn.getAttribute('amplitude-page-id');
    const contactInfoEventId = rmoContactInfoContinueBtn.getAttribute('amplitude-page-id');
    const moReviewEventId = reviewSubmitBtn.getAttribute('amplitude-page-id');

    const apiErrorCodeMap = JSON.parse(document.getElementById("apiErrorCodeMap").innerHTML);

    const getFormattedAmount = (amount) => {
        if(amount < 10) {
            return `00${amount}`
        } else if(amount < 100) {
            return `0${amount}`
        }
        return amount
    }

    const findStateKey = (value) => {
        let dataKey = ''
        for(let key in rmoStateKey) {
            if(rmoStateKey[key] === value) {
                dataKey = key
            }
        }
        return dataKey
    }

    const getCountryName = (name) => {
      return name?.toUpperCase() === 'UNITED STATES OF AMERICA' ? 'United States' : name
    }

    contactInfoPhoneNumberEl.addEventListener('input', function (e) {
      if(contactInfoFlagCode.classList.contains('us')){
        let formattedNum = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        e.target.value = !formattedNum[2] ? formattedNum[1] : '(' + formattedNum[1] + ') ' + formattedNum[2] + (formattedNum[3] ? '-' + formattedNum[3] : '');
      }
    });

    if(inputCountryCode) {
      inputCountryCode.addEventListener('click', (e) => {
        contactInfoCountryCodeInputDiv?.classList?.remove('d-flex');
      })
      inputCountryCode.addEventListener('input', (e) => {
        contactInfoCountryCodeInputDiv?.classList?.remove('d-flex');
        let value = e.target.value;
        let lis = contactInfoCountryCodeUlDropDown.querySelectorAll('li');
        Array.from(lis).forEach((li) => {
          if(li.innerText === ' ') {
          } else if (li.innerText.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
            li.classList.remove('d-none');
          } else {
            li.classList.add('d-none');
          }
        })
      })
    }

    contactInfoCountryCodeUlDropDown && contactInfoCountryCodeUlDropDown.addEventListener('click', (e) => {
      contactInfoCountryCodeInputDiv?.classList?.remove('d-flex');
    });
    contactInfoCountryCodeInputDiv && contactInfoCountryCodeInputDiv.addEventListener('click', (e) => {
      contactInfoCountryCodeInputDiv?.classList?.remove('d-flex');
    });

    if(contactInfoCountryCodeUlDropDown) {
      codeTransactionData.forEach((obj) => {
        let fragment = document.createDocumentFragment();
        let li = document.createElement('li');
        li.className = `wuds-dropdown__items b-flag-select__item`;
        let countryNameEL = document.createElement('span');
        countryNameEL.className = `wuds-dropdown__item-text`;
        countryNameEL.innerText = `${obj.country} (+${obj.code})`;
        let icon = document.createElement("i");
        icon.className = `wu-flag ${obj.iso.toLowerCase()} wu-flagSize--S`;
        li.setAttribute('data-value', `+${obj.code}`);
        li.appendChild(icon);
        li.appendChild(countryNameEL);
        fragment.appendChild(li);
        contactInfoCountryCodeUlDropDown.appendChild(fragment);
        li.addEventListener('mousedown', (e) => {
          inputCountryCode.value = `+${obj.code}`;
          inputCountryCode.setAttribute('value', inputCountryCode.value);
          inputCountryCode.setAttribute('data-value', inputCountryCode.value);
        })
      })
    }

    dropdownFeature(moDetailsScreen);
    dropdownFeature(contactInfoScreen);
    addressAttachToLocationFields(moDetailsScreen);
    addressAttachToLocationFields(contactInfoScreen);

    progressContact.addEventListener('click', (e) => showHideSectionBasedOnEditIcon(2));
    progressMo.addEventListener('click', (e) => showHideSectionBasedOnEditIcon(1));

    function filesValidation() {
        const fileTypesEL = document.querySelectorAll('input[type=file]');
        let error = false;
        Array.from(fileTypesEL).forEach((fileEl) => {
            if(fileEl.files.length === 0) {
                error = true;
                showFileValidationMessage(fileEl, 'text-file-error');
            } else {
                hideFileValidationMessage(fileEl);
            }
        })
        return error;
    }

    // Progress Bar
    function setWuProgressBarStep(step) {
      bars.forEach((bar, idx) => {
        if (idx <= step) {
          bar.classList.add('bk-green', 'bdr-color-green');
          bar.classList.remove('bk-grey-12', 'bdr-color-grey-02');
        } else {
          bar.classList.remove('bk-green', 'bdr-color-green');
          bar.classList.add('bk-grey-12', 'bdr-color-grey-02');
        }
      });
    }

    // Progress bar show/hide utility
    function toggleProgressBar(hide) {
      const progressBar = document.querySelector('.wu-container-progressbar');
      if (progressBar) {
        if (hide) {
          progressBar.classList.add('d-none');
        } else {
          progressBar.classList.remove('d-none');
        }
      }
    }

    // Step Show/Hide
    function showStep(incomingdiv) {
      if (incomingdiv.classList.contains(`d-none`)) {
        incomingdiv.classList.remove('d-none');
      } else {
        incomingdiv.classList.add('d-none');
      }

      // Progress bar show/hide
      const progressBar = document.querySelector('.wu-container-progressbar');
      if (progressBar) {
        if (incomingdiv === landingScreen) {
          progressBar.classList.add('d-none');
        } else {
          progressBar.classList.remove('d-none');
        }
      }

      // Progress bar step
      if (incomingdiv === landingScreen) return; // No progress bar on landing
      const stepOrder = [moneyOrderStatusScreen, moDetailsScreen, contactInfoScreen, reviewSubmitScreen];
      const stepIdx = stepOrder.indexOf(incomingdiv);
      if (stepIdx >= 0) setWuProgressBarStep(stepIdx);
    }

    function hideExistingStep(step) {
      if (step) {
        step.classList.add('d-none');
        step.classList.remove('d-block');
      }
    }

    function setInputValAttrOnChange(formEle,stepName){
      formEle.forEach((el)=>{
        el.addEventListener('blur',(e)=>{
          e.target.setAttribute('value', e.target.value);
          if(stepName === "MO_STATUS" )
            validateMoneyOrderStatusForm(e.target)
        })      
      })
    }

    function inputValidationsEvents(parentEl, validateOnSubmit) {
      let inputs = parentEl.querySelectorAll(
          "input:not([id^=country-dd]):not([id^=wu-input-payable-to]):not([id^=front-view]):not([id^=contact-apartment-number])"
        );
        let error = false;
        Array.from(inputs).forEach((inputEl) => {
            if(validateOnSubmit) {
                error = inputRMOValidation(inputEl, moNumbers) || error;
            } else {
              inputEl.addEventListener('blur', (e) => {
                  error = inputRMOValidation(inputEl, moNumbers) || error;
              });
              inputEl.addEventListener('input', debounceGeneric((e) => {
                  error = inputRMOValidation(inputEl, moNumbers) || error
              },1000));
            }
        });
        return error;
    }

    const drodpownValidationsEvent = (elements) => {
        let dropdownEls = elements.querySelectorAll('.wuds-dropdown')
        let isError = false;
        Array.from(dropdownEls).forEach((dropdownEl) => {
            let spanVal = dropdownEl?.querySelector('span.b-flag-select__value')
            if(spanVal?.innerHTML === '') {
                showValidationMessage(spanVal)
                dropdownEl.querySelector(".wu-input_flag-currency")?.setAttribute('style', 'top: 40%')
                isError = true;
            } else {
                dropdownEl.classList.remove('wu-input--error')
                spanVal && hideValidationMessage(spanVal)
            }
        })
        return isError
    }

    const drodpownEvent = (elements) => {
      let dropdownEls = elements.querySelectorAll('.wuds-dropdown:not([id^=country-code-input-div])')
      Array.from(dropdownEls).forEach((dropdownEl) => {
        dropdownEl.addEventListener('click', () => {
          var spanValueEl = dropdownEl.querySelector('.b-flag-select__value')
          var inputEl = dropdownEl.querySelector('.b-flag-select__search-field')
          var liElements = dropdownEl.querySelectorAll('li.b-flag-select__item')
          if(inputEl) {
            inputEl.setAttribute('data-value', '');
            inputEl.value = '';
          }
          if(spanValueEl)
            spanValueEl.innerHTML = ''
          if(liElements.length > 0) {
            Array.from(liElements).forEach(li => {
              li.classList.contains('d-none') && li.classList.remove('d-none')
            })
          }
        })
      })
    }
    
    drodpownEvent(moDetailsScreen);
    drodpownEvent(contactInfoScreen);

    //  Validation for Money Order detail form
    function validateMoneyOrderDetailForm() {
      let errorInputs = inputValidationsEvents(moDetailsScreen, true);
      let errorFiles = filesValidation();
      let errorDropdown = drodpownValidationsEvent(moDetailsScreen);
      const firstErrorEl = moDetailsScreen.querySelector('.wu-input.wu-input--error') || moDetailsScreen.querySelector('.file-selectors.text-red');
      firstErrorEl?.scrollIntoView();
      if (errorInputs || errorFiles || errorDropdown) return true;
    }
    inputValidationsEvents(moDetailsScreen);

    // Validation for Contact Info form
    function validateContactInfoForm() {
      let errorInputs = inputValidationsEvents(contactInfoScreen, true);
      let errorDropdown = drodpownValidationsEvent(contactInfoScreen);
      if (errorInputs || errorDropdown) return true;
    }
    inputValidationsEvents(contactInfoScreen);

    // Validation for Review and Submit form
    function validateReviewSubmitForm(isRmoConsentChecked, rmoSignatureValue) {
        if(humanKeyEL.value && isRmoConsentChecked && rmoSignatureValue) reviewSubmitBtn.removeAttribute('disabled');
        else reviewSubmitBtn.setAttribute('disabled', true);
    }

    // Validation for Money Order Status
    function validateMoneyOrderStatusForm(ele) {
      let hasError = false;
      if (!ele) {
        // Validate all fields if no specific element is passed
        hasError = inputRMOValidation(moNumberInput, moNumbers) || hasError;
        hasError = inputRMOValidation(amountInput, moNumbers) || hasError;
      } else if (ele === moNumberInput) {
        hasError = inputRMOValidation(moNumberInput, moNumbers) || hasError;
      } else if (ele === amountInput) {
        hasError = inputRMOValidation(amountInput, moNumbers) || hasError;
      }
      return !hasError;
    }

    function assignDropdownToFormData(inputEl, formDataKey, fallbackFn, fallbackValue = "") {
      if (!inputEl) return;
      const fallback = typeof fallbackFn === "function" ? fallbackFn() : fallbackValue;
      formData[formDataKey] = inputEl.getAttribute("data-slug") || inputEl.value || fallback;
      inputEl.addEventListener("change", function (e) {
        formData[formDataKey] = e.target.getAttribute("data-slug") || e.target.value || fallback;
      });
    }

     // Common function for state dropdown assignment
    function assignStateDropdownToFormData(inputEl, formDataKey) {
      if (!inputEl) return;
      const setValue = (el) => {
        const selectedValue = el.getAttribute('data-value') || el.value;
        formData[formDataKey] = selectedValue;
      };
      setValue(inputEl);
      inputEl.addEventListener('change', function (e) {
        setValue(e.target);
      });
      inputEl.addEventListener('click', function (e) {
        setValue(e.target);
      });
    }

    function focusInputOnDopClick(dopIconEl) {
      dopIconEl.addEventListener('click', (e) => {
          e.preventDefault();
          e.target.closest('.wu-input--bordered').querySelector('input').focus();
      });
    }

    function showApiErrorModal(heading, paragraph, type, paragraph2, errorCode) {
      const modal = document.getElementById('rmo_verifyStatusModal');
      const cancelBtn = document.getElementById('mo_btn_cancel');
      const continueBtnForModal = document.getElementById('mo_btn_continue');
      const cancelRequestBtnModal = document.getElementById('mo_btn_cancel_request');
      const continueBtnForR035Error = document.getElementById('continue_btn_r035');
      if (!modal) return;

      // Get heading and paragraph elements by ID
      const headingEl = modal.querySelector('#modal-validate-status-heading');
      const paraEl = modal.querySelector('#modal-validate-status-paragraph');
      const paraEl2 = modal.querySelector('#modal-validate-status-paragraph2');
      const successTick = modal.querySelector('#success-modal-tick');
      const errorCross = modal.querySelector('#error-modal-cross');

      // Set heading and paragraph text
      if (headingEl) headingEl.textContent = heading || 'Error';
      if (paraEl) paraEl.textContent = paragraph || 'An error occurred.';
      if (paraEl2) paraEl2.textContent = paragraph2;

      // Show/hide success/error icons using d-none
      if (type === 'success') {
        errorCross?.classList.add('d-none');
        cancelBtn?.classList.add('d-none');
        continueBtnForR035Error?.classList.add('d-none');
        successTick.classList.contains(`d-none`) ? successTick.classList.remove('d-none') : null;
        continueBtnForModal.classList.contains(`d-none`) ? continueBtnForModal.classList.remove('d-none') : null;
        cancelRequestBtnModal.classList.contains(`d-none`) ? cancelRequestBtnModal.classList.remove('d-none') : null;
      } else {
        if (errorCode === 'R035') {
          continueBtnForR035Error.classList.contains(`d-none`) ? continueBtnForR035Error.classList.remove('d-none') : null;
        } else {
          continueBtnForR035Error.classList.add('d-none');
        }
        errorCross.classList.contains(`d-none`) ? errorCross.classList.remove('d-none') : null;
        cancelBtn.classList.contains(`d-none`) ? cancelBtn.classList.remove('d-none') : null;
        successTick.classList.add('d-none');
        continueBtnForModal.classList.add('d-none');
        cancelRequestBtnModal.classList.add('d-none');
      }

      cancelBtn.setAttribute('amplitude-id', 'button-popup-cancel-' + errorCode);
      continueBtnForModal.setAttribute('amplitude-id', 'button-popup-continue-' + errorCode);
      cancelRequestBtnModal.setAttribute('amplitude-id', 'button-popup-cancel-request-' + errorCode);
      continueBtnForR035Error.setAttribute('amplitude-id', 'button-popup-continue-' + errorCode);

      // Show modal
      modal.classList.add('d-flex');
      modal.classList.remove('d-none');
    }

    function rmoProgressShowHide (showStatus, showMoneyOrder, showContact, reviewOrder) {
      showHideElements(moneyOrderStatusScreen, showStatus);
      showHideElements(moDetailsScreen, showMoneyOrder);
      showHideElements(contactInfoScreen, showContact);
      showHideElements(reviewSubmitScreen, reviewOrder);
    }

    function showHideSectionBasedOnEditIcon(count, eventObject) {
      if(eventObject) eventObject.preventDefault();

      if (count === 0) {
        rmoProgressShowHide(true, false, false, false);
        triggerAmplitudePageEvent(moStatusEventId);
      } else if (count === 1) {
        if(!validateMoneyOrderStatusForm()) return;
        rmoProgressShowHide(false, true, false, false);
        triggerAmplitudePageEvent(moOrderDetailsEventId);
      } else if (count === 2) {
        if(validateMoneyOrderDetailForm()) return;
        rmoProgressShowHide(false, false, true, false);
        triggerAmplitudePageEvent(contactInfoEventId);
      } else if (count === 3) {
        if(validateContactInfoForm()) return;
        rmoProgressShowHide(false, false, false, true);
        triggerAmplitudePageEvent(moReviewEventId);
      }
      setWuProgressBarStep(count);
    }

    async function verifyMoneyOrderApiCall() {
      const formSpinner = document.getElementById("spinnerContainer");
      showSpinnerMain(formSpinner);
      const moNumber = document.getElementById('wu-input-mo-number')?.value;
      const moAmount = document.getElementById('wu-input-mo-amount')?.value;
      const captcha = document.getElementById('humanKey')?.value;
      try {
        const url = location.host.startsWith('www3') ? `https://agent-services-qa.useast1.digitalnonprod.awswuintranet.net/rmosvc/v2/rmo/refund/status` : `/rmosvc/v2/rmo/refund/status`;
        const response = await fetchApiWu(url, {
          method: 'POST',
          headers: {
            'x-wu-externalRefId': '12345678',
            'Content-Type': 'application/json',
            'Accept-Language': 'en-us',
            'x-wu-correlationId': '344'
          },
          body: JSON.stringify({
            security: {
              captchaVerification: captcha || ''
            },
            serialNumber: moNumber,
            amount: moAmount
          })
        }, 'rmo-status');
        const data = await response;
        hideSpinnerMain(formSpinner);
        // Success codes
        const successCodes = ["R034", "R036", "R038", "R022", "R025", "R026", "R011", "R009", "R000"];
        let code = data.statusCode || data.errorCode;
        let config = apiErrorCodeMap[code] || apiErrorCodeMap["R041"];
        if (code && successCodes.includes(code)) {
          // Show modal for success (heading/paragraph only)
          showApiErrorModal(config.heading, config.paragraph, 'success', config.paragraph2, code);
          // Proceed to next step if needed
          formData.serialNumber = moNumber;
          formData.amount = moAmount;
          return;
        }
        // Error case: errorCode in object
        if (data.errorCode) {
          config = apiErrorCodeMap[data.errorCode] || apiErrorCodeMap["R041"];
          showApiErrorModal(config.heading, config.paragraph, 'error', config.paragraph2, data.errorCode);
          return;
        }
        // Fallback: if statusCode is not in successCodes, treat as error
        if (data.statusCode && !successCodes.includes(data.statusCode)) {
          config = apiErrorCodeMap[data.statusCode] || apiErrorCodeMap["R041"];
          showApiErrorModal(config.heading, config.paragraph, 'error', config.paragraph2, data.statusCode);
          return;
        }
        // Default error
        config = apiErrorCodeMap["R041"];
        showApiErrorModal(config.heading, config.paragraph, 'error');
      } catch (err) {
        hideSpinnerMain(formSpinner);
        let config = apiErrorCodeMap["R041"];
        showApiErrorModal(config.heading, config.paragraph, 'error');
      }
    }

    function cancelAndResetForm(e) {
      e.preventDefault();
      const continueBtn = document.getElementById('rmoStepsContinueBtn');
      const captchaInput = document.getElementById('humanKey');
      const modal = document.getElementById('rmo_verifyStatusModal');
      if (modal) {
        modal.classList.remove('d-flex');
        modal.classList.add('d-none');
      }

      if (moNumberInput) moNumberInput.value = '';
      if (amountInput) amountInput.value = '';
      if (captchaInput) captchaInput.value = '';

      if (grecaptcha) {
        grecaptcha.reset();
      }

      if (continueBtn) {
        continueBtn.setAttribute('disabled', true);
      }
    }

    // Step 1: Landing
    function initStep1() {
      const btn = landingScreen.querySelector('#rmoContinueBtn');
      const instructionBtn = landingScreen.querySelector('#btn-money-order-instruction');
      const moneyOrderDisclaimer = landingScreen.querySelector('.mo-disclaimer');
      const moRefundInstructionElement = landingScreen.querySelector('.collpase-mo-refund-instruction');

      if (btn) {
        btn.disabled = false;
        btn.onclick = e => {
          e.preventDefault();
          triggerAmplitudePageEvent(moStatusEventId);
          hideExistingStep(landingScreen)
          showStep(moneyOrderStatusScreen);
          initStep2();
        };
      }
     
      if (instructionBtn && moneyOrderDisclaimer) {
        instructionBtn.onclick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (moneyOrderDisclaimer.classList.contains('d-none')) {
          moneyOrderDisclaimer.classList.remove('d-none')
          moRefundInstructionElement.querySelector('.plus').classList.add('d-none')
          moRefundInstructionElement.querySelector('.minus').classList.remove('d-none')
        }
          else {
          moneyOrderDisclaimer.classList.add('d-none')
          moRefundInstructionElement.querySelector('.minus').classList.add('d-none')
          moRefundInstructionElement.querySelector('.plus').classList.remove('d-none')
        } 
      };
      
      }
    }

    // Step 2: MO Verify Status
    function initStep2() {

      //To Hide the RMO header
      if(rmoHeader){
        rmoHeader.classList.add('d-none')
      }
      // Add validation on input change for MO number and amount
      const continueBtn = document.getElementById('rmoStepsContinueBtn');
      const moInputEle = moneyOrderStatusScreen.querySelectorAll('.mo_status_input');
      const cancelBtn = document.getElementById('mo_btn_cancel');
      const captchaInput = document.getElementById('humanKey');
      const continueBtnForModal = document.getElementById('mo_btn_continue');
      const cancelRequestBtnModal = document.getElementById('mo_btn_cancel_request');


      if (continueBtn) {
        continueBtn.disabled = !captchaInput || !captchaInput.value;
      }

      document.addEventListener('captchaSuccessEvent', function() {
        if (continueBtn) {
          continueBtn.disabled = !captchaInput || !captchaInput.value;
        }
      });

      if (moNumberInput) {
        moNumberInput.addEventListener('input', validateMoneyOrderStatusForm);
        moNumberInput.onkeydown = (event) => {
      // Allow: numbers, Backspace, and keyboard shortcuts (Ctrl/Cmd)
          if (
            (isNaN(event.key) && event.key !== "Backspace"&& event.key !== "Tab") &&
            !(event.ctrlKey || event.metaKey)
          ) {
            event.preventDefault();
          }
        };
    }
      if (amountInput) {
        amountInput.addEventListener('input', validateMoneyOrderStatusForm);
      }
      setInputValAttrOnChange(moInputEle, "MO_STATUS");

      if (continueBtn) {
        continueBtn.onclick = function (e) {
          e.preventDefault();
          if (!validateMoneyOrderStatusForm()) {
            return false;
          } else {
            formData.serialNumber = moNumberInput.value;
            formData.amount = amountInput.value;
            formData.captcha = captchaInput.value;
            verifyMoneyOrderApiCall();
          }
        };
      }

      if (cancelBtn) {
        cancelBtn.onclick = cancelAndResetForm;
      }
      
      if(continueBtnForModal){
        continueBtnForModal.onclick = function(e) {
          triggerAmplitudePageEvent(moOrderDetailsEventId);
          hideExistingStep(moneyOrderStatusScreen);
          showStep(moDetailsScreen);
          initStep3();
        };
      }

      if(cancelRequestBtnModal){
        cancelRequestBtnModal.onclick = cancelAndResetForm;
      }

    }

      // Step 3: Money Order Details
    function initStep3() {
      const cityEl = moDetailsScreen.querySelector('#input-city-data');
      const dopEl = moDetailsScreen.querySelector('#wu-input-date-purchase');
      const refundReasonDropdown = moDetailsScreen.querySelector('#refundReasonDropdown');
      const refundReason = refundReasonDropdown?.querySelector('.b-flag-select__search-field');
      const refundReasonList = refundReasonDropdown?.querySelector('.b-flag-select__list');
      const moDetailInput = moDetailsScreen.querySelectorAll('.moDetailInput');
      const additionalInput = moDetailsScreen.querySelector('#text-area-additional-info');
      focusInputOnDopClick(dopIconEl);
      const proofPurchaseDropdown = moDetailsScreen.querySelector('#proofPurchaseSection');
      const proofPurchase = proofPurchaseDropdown?.querySelector('.b-flag-select__search-field');
      const proofPurchaseList = proofPurchaseDropdown?.querySelector('.b-flag-select__list');
      const uploadedMoneyOrderImage = moDetailsScreen?.querySelector('#front-view');
      setInputValAttrOnChange(moDetailInput, 'MO_DETAILS');
      additionalInput.addEventListener('input',(e)=>{
         e.target.setAttribute('value', e.target.value);
      })
      // Enable file upload for front view
      const rmoDetailFileUpload = moDetailsScreen.querySelector('#rmo-detail-file-upload');
      if (rmoDetailFileUpload) {
        // Get fileSelectors for details step
        const detailFileSelectors = rmoDetailFileUpload.querySelectorAll('.file-selectors');
        fileSelectorFunctionality(detailFileSelectors);
        changeFileInputListener(rmoDetailFileUpload);
        formData.fileImage = uploadedMoneyOrderImage;
      }
      
      // Enable dynamic state dropdown for details step
      stateFeature(moInfoCountryDropdownEl, moInfoStateDropdownEl);
      // Kindly verify if code is working with dropdown then remove  following code
      let refundList = refundReasonList?.querySelectorAll('li');
      if (refundList) {
        refundList?.forEach((li) => {
          li.addEventListener('click', (e) => {
            refundReason = e.target.innerText;
            formData.refundReason = refundReason;
          });
        });
      }

      let proofList = proofPurchaseList?.querySelectorAll('li');
      if (proofList) {
        proofList?.forEach((li) => {
          li.addEventListener('click', (e) => {
            proofPurchase = e.target.innerText;
            formData.proofPurchase = proofPurchase;
          });
        });
      }

      setDatePickers(dopEl);

      if (rmoDetailContinueBtn) {
        rmoDetailContinueBtn.disabled = false;
        rmoDetailContinueBtn.onclick = function (e){
            e.preventDefault();
            if(validateMoneyOrderDetailForm()) {
              return;
            } else {
              formData.storeName = moDetailsScreen.querySelector('#mo-location-name')?.value;
              formData.city = moDetailsScreen.querySelector('#wu-input-city')?.value;
              formData.state = moDetailsScreen.querySelector('#rmo-detail-state-dropdown')?.value;
              formData.zip = moDetailsScreen.querySelector('#wu-input-zip')?.value;
              formData.moneyOrderCountry = moDetailsScreen.querySelector('#country-dropdown')?.value;
              formData.dateOfPurchase = moDetailsScreen.querySelector('#wu-input-date-purchase')?.value;
              formData.payableTo = moDetailsScreen.querySelector('#wu-input-payable-to')?.value;
              formData.additionalInfo = moDetailsScreen.querySelector('#text-area-additional-info')?.value;
              formData.proofDocumentType= moDetailsScreen.querySelector('#proofPurchaseEle')?.value;
              formData.moneyOrderReason = moDetailsScreen.querySelector('#reason-refund-dropdown')?.value
              assignStateDropdownToFormData( moDetailsScreen?.querySelector('#rmo-detail-state-dropdown'),'stateCode');
              assignDropdownToFormData( moInfoCountryDropdownEl, "moneyOrderCountryCode",() => getAkCountryRMO().toLowerCase(),"us");
              triggerAmplitudePageEvent(contactInfoEventId);
              hideExistingStep(moDetailsScreen);
              showStep(contactInfoScreen);
              initStep4();
            }
        };
      }
    }

    // Step 4: Contact Information
    function initStep4() {
      const contactInfoInput = contactInfoScreen.querySelectorAll('input[class*=wu-input]');
      stateFeature(contactInfoCountryDropdownEl,contactInfoStateDropdownEl);
      setInputValAttrOnChange(contactInfoInput, "CONTACT_INFO_STATUS");

      if (rmoContactInfoContinueBtn) {
        rmoContactInfoContinueBtn.disabled = false;
        rmoContactInfoContinueBtn.onclick = function (e) {
            e.preventDefault();
            if(validateContactInfoForm()) {
              return;
            } else {
                formData.firstName = contactInfoScreen.querySelector('#contact-first-name')?.value;
                formData.lastName = contactInfoScreen.querySelector('#contact-last-name')?.value;
                formData.email = contactInfoScreen.querySelector('#contact-email-id')?.value;
                formData.countryCode = contactInfoScreen.querySelector('#country-dd')?.value;
                formData.phone = contactInfoScreen.querySelector('#contact-phone-number')?.value;
                formData.address = contactInfoScreen.querySelector('#contact-address')?.value;
                formData.apartment = contactInfoScreen.querySelector('#contact-apartment-number')?.value; //not in figma
                formData.contactCity = contactInfoScreen.querySelector('#wu-input-city')?.value;
                formData.contactStateName = contactInfoScreen.querySelector('#state-dropdown')?.value;
                formData.contactZip = contactInfoScreen.querySelector('#wu-input-zip-code')?.value;
                formData.contactCountry = contactInfoScreen.querySelector('#country-dropdown-contact')?.value;
                assignStateDropdownToFormData( contactInfoScreen.querySelector('#state-dropdown'),'contactStateCode');
                assignDropdownToFormData( contactInfoCountryDropdownEl ,"contactCountryCode",() => getAkCountryRMO().toLowerCase(),"us");
                triggerAmplitudePageEvent(moReviewEventId);
                hideExistingStep(contactInfoScreen);
                showStep(reviewSubmitScreen);
                initStep5();
              
            }
        };
      }
    }

    // Step 5: Review and Submit
    function initStep5() {
      const modal = document.getElementById("review-modal");
      const successTick = document.getElementById("review-success-modal-tick");
      const errorCross = document.getElementById("review-error-modal-cross");
      const headingSuccess = document.getElementById("review-modal-success-heading");
      const headingUnsuccess = document.getElementById("review-modal-unsuccessful-heading");
      const paraSuccess = document.getElementById("review-modal-success-paragraph");
      const paraUnsuccess = document.getElementById("review-modal-unsuccessful-paragraph");
      const btnContinue = document.getElementById('review_modal_btn_continue');
      const btnCancel = document.getElementById('review_modal_btn_cancel');

      btnCancel.addEventListener('click', () => window.location.reload());
      btnContinue.addEventListener('click', () => window.location.reload());

        // Set contact info values in review screen
      const nameEl = reviewSubmitScreen.querySelector('.total-name');
      const emailEl = reviewSubmitScreen.querySelector('.email');
      const phoneEl = reviewSubmitScreen.querySelector('.phone');
      const addressEl = reviewSubmitScreen.querySelector('.address');
      if (nameEl) nameEl.innerText = `${formData.firstName || ''} ${formData.lastName || ''}`.trim();
      if (emailEl) emailEl.innerText = formData.email || '';
      if (phoneEl) phoneEl.innerText = formData.phone || '';
      const addressContact = `${formData.address}, ${formData.apartment ? formData.apartment + "," : ''} ${formData.contactCity}, ${findStateKey(formData.contactStateName)}, ${formData.contactZip}, ${formData.contactCountry}`;
      if (addressEl) addressEl.innerText = addressContact;

       // Set money order info values in review screen
      const moNumberEl = reviewSubmitScreen.querySelector('.review-mo-number');
      const moAmountEl = reviewSubmitScreen.querySelector('.review-mo-amount');
      const moDopEl = reviewSubmitScreen.querySelector('.review-mo-dop');
      const moPayableEl = reviewSubmitScreen.querySelector('.review-mo-payable');
      const moReasonEl = reviewSubmitScreen.querySelector('.review-mo-reason');
      const moLocationEl = reviewSubmitScreen.querySelector('.review-mo-location');

      if (moNumberEl) moNumberEl.innerText = formData.serialNumber || '';
      if (moAmountEl) moAmountEl.innerText = formData.amount ? `$${formData.amount}` : '';
      if (moDopEl) moDopEl.innerText = formData.dateOfPurchase || '';
      if (moPayableEl) moPayableEl.innerText = formData.payableTo || '';
      if (moReasonEl) moReasonEl.innerText = formData.moneyOrderReason || '';
      if (moLocationEl) moLocationEl.innerText = formData.storeName || '';

      if (reviewSubmitBtn) {
        document.addEventListener('rsCaptchaSuccessEvent' , () => {
          validateReviewSubmitForm(rmoConsent.checked, rmoSignature.value);
        });

        rmoConsent.addEventListener("change", (e) => {
          validateReviewSubmitForm(e.target.checked, rmoSignature.value);
        });

        rmoSignature.addEventListener("input", (e) => {
          rmoSignature.setAttribute("value", rmoSignature.value);
          validateReviewSubmitForm(rmoConsent.checked, rmoSignature.value);
        });

        reviewSubmitBtn.addEventListener("click", async (e) => {
          e.preventDefault();
          
          // Prevent multiple clicks
          if (reviewSubmitBtn.disabled || reviewSubmitBtn.classList.contains('is-submitting')) {
            return;
          }
          
          // Disable button immediately to prevent duplicate submissions
          reviewSubmitBtn.disabled = true;
          reviewSubmitBtn.classList.add('is-submitting');
          const originalButtonText = reviewSubmitBtn.textContent;
          reviewSubmitBtn.textContent = 'Processing...';
          
          // Spinner
          const formSpinner = document.getElementById("spinnerContainer");
          showSpinnerMain(formSpinner);

          // Collect review/consent values
          formData.consent = rmoConsent.checked ? "Allowed" : "Not Allowed";
          formData.signature = rmoSignature.value;

          let imgArray = [];
          if (formData.fileImage?.files?.length > 0) {
            imgArray = await getDataFromUploadedFile([
              formData.fileImage.files[0],
            ]);
          }

          const refundPayload = {
            security: {
              captchaVerification: humanKeyEL?.value || "",
            },
            customer: {
              name: {
                first: formData.firstName || "",
                middle: null,
                last: formData.lastName || "",
                secondLast: null,
              },
              address: {
                addressLine1: formData.address || "",
                city: formData.contactCity || "",
                stateCode: findStateKey(formData.contactStateName) || "",
                stateName: formData.contactStateName || "",
                countryCode: formData.contactCountryCode || "",
                countryName: getCountryName(formData.contactCountry) || "",
                postalCode: formData.contactZip || "",
                type: "PRIMARY",
                apartmentNumber: formData.apartment || "",
              },
              phoneNumber: [
                {
                  countryCode: formData.countryCode ? formData.countryCode.replace("+", "") : "",
                  number: formData.phone ? formData.phone.replace(/\D+/g, "") : "",
                  type: "CELL_PHONE",
                },
              ],
              email: formData.email || "",
            },
            refundMethod: "Cash Pickup", 
            consent: formData.consent,
            signature: formData.signature,
            signedDate: new Date().toISOString().slice(0, 10).replace(/-/g, "/"),
            moneyOrders: [
              {
                payAmount: formData.amount ? getFormattedAmount(Math.round(formData.amount * 100)) : 0,
                serialNumber: formData.serialNumber || "",
                reason: formData.moneyOrderReason || "",
                payTo: formData.payableTo || "",
                date:  getFormattedDateYYYMMDD(formData.dateOfPurchase) || "",
                documents: imgArray,
                address: {
                  addressLine1: formData.storeName || "",
                  city: formData.city || "",
                  stateCode: findStateKey(formData.state) || "",
                  stateName: formData.state || "",
                  countryName: getCountryName(formData.moneyOrderCountry) || "",
                  countryCode: formData.moneyOrderCountryCode || "",
                  postalCode: formData.zip || "",
                },
              },
            ],
            isOfflineCase: false,
            suppliedComment: formData.additionalInfo || "",
            caseDocumentType: formData.proofDocumentType || "",
          };

          try {
            const url = location.host.startsWith('www3') ? `https://agent-services-qa.useast1.digitalnonprod.awswuintranet.net/rmosvc/v1/rmo/refund/request` : `/rmosvc/v1/rmo/refund/request`;
            const response = await fetchApiWu(url,
              {
                method: "POST",
                headers: {
                  accept: "application/json, text/plain, */*",
                  "Content-Type": "application/json",
                  "accept-language": "en-US,en;q=0.9",
                  "x-wu-correlationId": `rmo-${randomStringGenerator(
                    0x1000000
                  )}-${randomStringGenerator(0x100)}`,
                  "x-wu-externalRefId": `rmo-refund-${randomStringGenerator(
                    0x100000
                  )}`,
                },
                body: JSON.stringify(refundPayload),
              }, 'rmo-request'
            );
            const data = await response;
            hideSpinnerMain(formSpinner);
              modal?.classList.add("d-flex");
              modal?.classList.remove("d-none");
              if (data?.refunds[0]?.status === "Success") {
                // Success - keep button disabled, user shouldn't resubmit
                successTick?.classList.remove("d-none");
                errorCross?.classList.add("d-none");
                headingSuccess?.classList.remove("d-none");
                paraSuccess?.classList.remove("d-none");
                headingUnsuccess?.classList.add("d-none");
                paraUnsuccess?.classList.add("d-none");
                btnContinue?.classList.remove("d-none");
                btnCancel?.classList.add("d-none");
              } else {
                // API returned error - re-enable button for retry
                reviewSubmitBtn.disabled = false;
                reviewSubmitBtn.classList.remove('is-submitting');
                reviewSubmitBtn.textContent = originalButtonText;
                
                successTick?.classList.add("d-none");
                errorCross?.classList.remove("d-none");
                headingSuccess?.classList.add("d-none");
                paraSuccess?.classList.add("d-none");
                headingUnsuccess?.classList.remove("d-none");
                paraUnsuccess?.classList.remove("d-none");
                btnContinue?.classList.add("d-none");
                btnCancel?.classList.remove("d-none");
              }
      } catch (err) {
        // Exception occurred - re-enable button for retry
        hideSpinnerMain(formSpinner);
        reviewSubmitBtn.disabled = false;
        reviewSubmitBtn.classList.remove('is-submitting');
        reviewSubmitBtn.textContent = originalButtonText;
        
        modal?.classList.add("d-flex");
        modal?.classList.remove("d-none");
        successTick?.classList.add("d-none");
        errorCross?.classList.remove("d-none");
        headingSuccess?.classList.add("d-none");
        paraSuccess?.classList.add("d-none");
        headingUnsuccess?.classList.remove("d-none");
        paraUnsuccess?.classList.remove("d-none");
        btnContinue?.classList.add("d-none");
        btnCancel?.classList.remove("d-none");
          }
        });
      }
    }

    // Main Flow Init
    function startRefundFlow() {
      toggleProgressBar(true);
      initStep1();
    }
    if (rmoStatusCheck === "true") {
      hideExistingStep(landingScreen);
      showStep(moneyOrderStatusScreen);
      initStep2();
      hideSpinnerMain();
    } else {
      startRefundFlow();
    }

    if(bars) {
      Array.from(bars).forEach((bar, index) => {
        bar.addEventListener('click' , () => {
          showHideSectionBasedOnEditIcon(index);
        })
      })
    }
  }
